module.exports = __webpack_public_path__ + "img/flaggstikk_ferdig.9afe7051.jpg";